import { fromJS } from 'immutable';

import {ApiUrl2, PrevilageId, UserToken} from '../../../helper/HelperAuth'
import { GetDivisionAll } from '../../../store/constants'
import doFetch from '../../../infra/helper/fetchHelper'

export default (clientid, menuname) => async (dispatch, getState) => {

    const Authorization = UserToken;
    let action = 0;
    
    const url = ApiUrl2 + '/user-division-list';
    if(clientid == null || clientid === undefined){
        clientid=1;
    }

    if (menuname != '' || menuname != undefined || menuname != null) {
        const urlAccess = ApiUrl2 + 'config-accessmodule-list';
        var paramBodyAccess = {
            "query":{
                "privilege-id":PrevilageId,
            }
        };
        const argumentAccess = {
            method: 'POST',
            headers : {
                'Content-Type':'application/json',
                'Authorization': Authorization,
            },
            body : JSON.stringify(paramBodyAccess)
        };

        const responseAccess = await doFetch(urlAccess,argumentAccess);
        let dataAccess = fromJS({});
        let array = [];
        let show = '';
        if(responseAccess.ok){
            dataAccess = fromJS(await responseAccess.json());
            dataAccess = dataAccess.get('query-result');
        }

        let menuPrev = fromJS(dataAccess).get('data')
        {menuPrev.map((data, i) =>
            array.push({
                'menu-name' :data.get('menu-name'),
                'action-id' : data.get('action-id')
            })

        )}
        for (let i = 0; i < array.length; i++) {
            if (array[i]['menu-name'] === menuname) {
                action = array[i]['action-id']
            }
        }
    }


    var paramBody = {
        "query":{
            "search":"",
            "page":1,
            "page-size":1000,
            "order-by":1,
            "order":"ASC",
            "client-id":clientid
        }
    };

    if (action == 3 || action == 4) {
        paramBody = {
            "query":{
                "search":"",
                "page":1,
                "page-size":1000,
                "order-by":1,
                "order":"ASC",
                "client-id":clientid,
                "show": "all"
            }
        };
    }

    const argument = {  
        method: 'POST',
        headers : {
            'Content-Type':'application/json',
            'Authorization': Authorization,
        },
        body : JSON.stringify(paramBody)
    };  

    const response = await doFetch(url,argument);
    var data = fromJS({});
    if(response.ok){
        data = fromJS(await response.json());
        data = data.get('query-result');
        data = data.get('data');
    }

    

    dispatch({ type: GetDivisionAll, data: fromJS(data) });
};